<template>
	<div class="home" v-if="!loading">
	<HeaderTopBar :info="info" :hideSidebar="hideSidebar()" v-if="!isBdrUser(['Rejected (interview)', 'Rejected (trial)', 'Stopped'])" />
	  <Sidebar v-show="!hideSidebar()" />
	  <template v-if="!isBdrUser(['Screening', 'Onboarding', 'Outdated'])">
		  
		  <ToastNotifications />
		  <keep-alive>
			  <router-view class="px-4" v-if="$route.meta.keepAlive" :key="computedKey"  @updateHeader="updateHead"></router-view>
		  </keep-alive>
	  </template>
  
	  <router-view class="px-4" v-if="!$route.meta.keepAlive" :key="computedKey" @updateHeader="updateHead"></router-view>
  
	   <Footer class="px-4" v-if="!isBdrUser(['Screening', 'Onboarding', 'Rejected (interview)', 'Rejected (trial)', 'Outdated', 'Stopped'])"/>
	</div>
  </template>
  
  <script lang="js">
	  import Sidebar from '@/components/Sidebar';
	  import HeaderTopBar from '@/components/HeaderTopBar.vue';
	  import ToastNotifications from "@/components/ToastNotifications.vue";
	  import Footer from "@/components/Footer.vue";
  
  
	  export default {
		  name: 'home',
		  components: {
			  Sidebar,
			  HeaderTopBar,
			  ToastNotifications,
			  Footer
		  },
		  data () {
			  return { 
				  loading: true,
				  info:''
			  }
		  },
		  watch:{
			  $route(to,from){
				  this.info = null
			  },
		  },
		  computed: {
			  user() {
					return this.$store.state.authentication.user;
			  },
			  isBdrUser() {
				  return (status) => {
					  if(status){
						  if (this.user.team_role_id == 2 && this.user.role_id == 2 && status.includes(this.user.booker.status)) {
							  return true
						  }
					  }        
					  return false
				  }
				  },
			  computedKey() {			
			  const routesWithKey = [
				  '/syncemails', 
				  '/oliver_sales_dashboard',
				  '/allperformances',
				  '/allinfrastructure',
				  '/dashboard/tabs',
				  '/orders-by-lang'
			  ];			
			  
			  if (this.$route.fullPath.startsWith('/syncemails') || 
				  this.$route.fullPath.startsWith('/oliver_sales_dashboard') ||
				  this.$route.fullPath.startsWith('/dashboard/tabs') ||
				  this.$route.fullPath.startsWith('/allperformances') || 
				  this.$route.fullPath.startsWith('/allinfrastructure') || 
				  this.$route.fullPath.startsWith('/allbdr') ||
				  this.$route.fullPath.startsWith('/orders-by-lang')) {
				  return this.$route.fullPath;
			  }
			  
			  return routesWithKey.includes(this.$route.fullPath) ? this.$route.fullPath : null;
			  }
		  },
		  created() {
			  const { dispatch } = this.$store;
			  dispatch("authentication/refreshToken").then(
				  (response) => {
					  this.loading = false;
				  }  
			  )
		  },
		  methods:{
			   updateHead(emit){
				  this.info = emit
			   },
			   hideSidebar(){
				  return this.user.role_id == 1 && this.isMobile;
			   }
		  }
	  }
  </script>
  